import React from "react";
import { Form } from "react-bootstrap";
import { Field } from "redux-form";

import { SwitchComponent } from "components";

export const GenericInput = ({
	input,
	type,
	meta: { touched, error },
	normalizeOnBlur,
	...props
}) => {
	const handleBlur = e => {
		if (normalizeOnBlur) {
			e.target.value = normalizeOnBlur(e.target.value);
		}

		input.onBlur(e);
	};

	return (
		<div style={{ position: "relative" }}>
			<Form.Control
				{...input}
				{...props}
				type={type}
				className={touched && error && "invalid"}
				onBlur={handleBlur}
			/>
			{touched && error && <div className="errorMessage">{error}</div>}
		</div>
	);
};

const renderRadioOption = (option, input) => (
	<Form.Check
		key={option.id}
		id={option.id}
		type="radio"
		custom
		label={option.label}
		{...input}
		value={option.value}
		checked={option.value === input.value}
	/>
);

const renderRadioGroup = ({ input, options }) =>
	options.map(option => renderRadioOption(option, input));

export const RadioGroup = ({ name, options }) => {
	return <Field component={renderRadioGroup} name={name} options={options} />;
};

export const getEmailPhoneOptionsFor = name => [
	{ id: name + "None", label: "None", value: "" },
	{ id: name + "Email", label: "By Email", value: "email" },
	{ id: name + "Phone", label: "By Phone", value: "phone" },
	{
		id: name + "EmailAndPhone",
		label: "By Email and Phone",
		value: "email_phone",
	},
];

export const getYesNoOptionsFor = name => [
	{ id: name + "Yes", label: "Yes", value: "yes" },
	{ id: name + "No", label: "No", value: "no" },
];

export const Switch = props => {
	return (
		<SwitchComponent
			label={props.label}
			enabled={props.input.value}
			{...props.input}
		/>
	);
};

export const Checkbox = ({ input, meta, ...props }) => {
	return (
		<Form.Check
			custom
			type="checkbox"
			checked={input.value}
			{...input}
			{...props}
			id={`${props.id}checkbox`}
		/>
	);
};

export const MerchantOptionLabel = option => (
	<>
		<span>{option.dba_name}</span>
		&nbsp;
		<span
			style={{
				fontWeight: "bold",
				color: "rgba(255, 255, 255, 0.7)",
			}}
		>
			({option.number})
		</span>
	</>
);

export const NoMerchantsMessage = () => "Merchant not found";
export const StartTypingMessage = () => "Start Typing";
